import type { RecordingHit } from './types';

export type SearchRecordingsResult = {
  query: string;
  total: number;
  recordings: RecordingHit[];
  presentation?: string;
};

export const parseSearchResult = (
  content: string | undefined,
): SearchRecordingsResult | null => {
  if (!content) return null;
  try {
    const parsed = JSON.parse(content) as SearchRecordingsResult;
    if (Array.isArray(parsed.recordings)) return parsed;
  } catch {
    /* not a recording search result */
  }
  return null;
};
